import { html, ref } from '@microsoft/fast-element';
/**
 * The Grid Pro Template.
 * @public
 */
export const gridProTemplate = html `
  <template>
    <span part="grid" class="${(x) => x.classNames}">
      <slot name="grid" ${ref('gridSlot')}></slot>
      <slot></slot>
    </span>
  </template>
`;
